import {useCallback} from 'react';
import {useNode} from '@craftjs/core';
import {useEditorStyle} from 'hooks';
import {classNames} from 'utils';
import QRCode from 'react-qr-code';

interface IEditorContentQRProps {
  mobileStyle?: React.CSSProperties;
}

const EditorContentQR = ({mobileStyle, ...props}: IEditorContentQRProps) => {
  const {
    connectors: {connect, drag},
    selected,
    hovered,
  } = useNode(node => ({
    selected: node.events.selected,
    hovered: node.events.hovered,
  }));

  const ref = useCallback((node: HTMLImageElement) => {
    if (node) {
      connect(drag(node));
    }
  }, []);

  const {device, style: editorStyle} = useEditorStyle();
  const style = device === 'desktop' ? editorStyle : {...editorStyle, display: 'none'};
  const link = location.href;

  return (
    <div {...props} ref={ref} className="relative" style={style}>
      <div
        className={classNames(
          'absolute inset-0 pointer-events-none',
          hovered ? 'shadow-[inset_0_0_0_2px_#34bb78]' : selected ? 'shadow-[inset_0_0_0_2px_#acbdd4]' : '',
        )}></div>
      <QRCode value={link} style={{width: '100%', height: '100%'}} />
    </div>
  );
};

EditorContentQR.craft = {
  displayName: 'QRCode',
  custom: {
    icon: 'QrCodeIcon',
  },
  props: {
    style: {
      width: '40%',
      height: '100%',
      maxWidth: '1080px',
      maxHeight: '1080px',
      backgroundColor: 'white',
      borderRadius: '10px',
      padding: '10px 10px 10px 10px',
      boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
      margin: '0 0 0 0',
    },
    mobileStyle: {},
  },
};

export default EditorContentQR;
